<template>
  <transition>
    <div class="modal" @click="$emit('click')">
      <img class="modal-image" :src="url" :alt="title" />
    </div>
  </transition>
</template>

<script>
export default {
  data(){
    return {
      show: false
    }
  },
  props: {
    url: String,
    title: String
  },
}
</script>

<style lang="less">
  .modal{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background: rgba(255,255,255,.8);
    display: flex;
    align-items: center;
    .modal-image{
      display: block;
      margin: 0 auto;
    }
  }
</style>